import {L} from "./util.js";
import {SDP} from './sdputil.js';
const peer_actions={
 set_ice_candidate: function(pc) {
  if(!pc.ice_candidate_list.length) return;
  pc.ice_candidate_list.forEach(c=>pc.addIceCandidate(new window.XIceCandidate(c)));
  pc.ice_candidate_list=[];
 },
 make_offer: function make_offer(pp,cb) {
  if(pp.restart) L.info(`Offer to restart ice for : ${pp.pc.name}`);
  const pc=pp.pc;
  pc.createOffer(Object.assign({
    offerToReceiveAudio: 1,
    offerToReceiveVideo: 1
   },pp.restart&&{iceRestart:true})
  ).then(
   (sdp)=>(
    sdp.sdp=SDP.prefer_audio_send_codec(sdp.sdp,{audiosendcodec:pp.audiocodec||'opus'}),
    sdp.sdp=SDP.prefer_video_send_codec(sdp.sdp,{videosendcodec:pp.videocodec||'H264'}),
    pc.setLocalDescription(sdp).then(
    ()=>cb(null,sdp)
    ).catch(cb)
   )
  ).catch(cb);
 },
 make_answer: function process_offer(pp,cb){
  const pc=pp.pc;
  pc.setRemoteDescription(new window.XSessionDescription(pp.sdp)).then(()=>{
   pc.createAnswer({offerToReceiveAudio: 1,offerToReceiveVideo: 1}).then(
    (sdp)=>(
     sdp.sdp=SDP.prefer_audio_send_codec(sdp.sdp,{audiosendcodec:pp.audiocodec||'opus'}),
     sdp.sdp=SDP.prefer_video_send_codec(sdp.sdp,{videosendcodec:pp.videocodec||'H264'}),
     pc.setLocalDescription(sdp).then(
      ()=>peer_actions.set_ice_candidate(pc),cb(null,sdp)
     ).catch(cb)
    )
   ).catch(cb);
  }).catch(cb);
 },
 process_answer: function process_answer(pp,cb) {
  const pc=pp.pc;
  pc.setRemoteDescription(new window.XSessionDescription(pp.sdp)).then(
   ()=>{peer_actions.set_ice_candidate(pc),cb()}
  ).catch(cb);
 }
};

export const PEER={
 connections: {},
 makeanswer: peer_actions.make_answer,
 processanswer: peer_actions.process_answer,
 makeoffer: peer_actions.make_offer
};